class EdgeDistanceValues {
  static defaultEdgeDistance = 200
}

export default EdgeDistanceValues
